import React  from 'react';
import { Header, tableBetHistoryStore } from '@pascal/pascal-core';
import { GameControllerTypes } from '@pascal/pascal-core/table-line/t_types/enums/GameControllerTypes';
import { Settings } from '@pascal/pascal-core/table-line';
import { BetHistoryWrp } from '../betHistory';
import gameLogo from '../../assets/images/logo.png';
import { HelpPopup } from '../helpPopup';
import { observer } from 'mobx-react-lite';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';


export const HeaderContent = observer(() => {
  const { setSelectedHistoryRow, selectedHistoryRow } = tableBetHistoryStore;
  const { currencySymbolOrCode } = userInfoStore;


  return (
    <Header
      logoSrc={gameLogo}
      currencyCode={currencySymbolOrCode}
      lobbyPath={null}
      isShowFairness={false}
      selectedHistoryRow={selectedHistoryRow}
      setSelectedHistoryRow={setSelectedHistoryRow}
      gameControllerComponents={{
        [GameControllerTypes.Help]: <HelpPopup />,
        [GameControllerTypes.History]: <BetHistoryWrp />,
        [GameControllerTypes.Settings]: <Settings />,
      }}
    />
  );
});
